import { reportClientError } from './reportClientError';

// Feeds uncaught errors and unhandled promise rejections into the client-error ring (reportClientError, vendored from
// ptc-core). In statetax that ring is LOCAL ONLY (no VITE_CLIENT_ERROR_ENDPOINT, so nothing is beaconed). Its one reader is
// the feedback widget's context (contract v1 §2 `recentErrors`), so a "Report a problem" sent after something broke carries
// what broke, instead of an always-empty list. reportClientError caps reports per session and drops re-entrant errors.

let installed = false;

export function installGlobalErrorCapture(target: Pick<Window, 'addEventListener'> = window): void {
  if (installed) return;
  installed = true;
  target.addEventListener('error', (e: Event) => {
    const ev = e as ErrorEvent;
    const error = ev.error instanceof Error ? ev.error : new Error(ev.message || 'Script error');
    reportClientError(error, { source: 'window.error' });
  });
  target.addEventListener('unhandledrejection', (e: Event) => {
    const reason = (e as PromiseRejectionEvent).reason as unknown;
    reportClientError(reason instanceof Error ? reason : new Error(String(reason)), { source: 'unhandledrejection' });
  });
}

/** Exposed for tests. */
export function __resetGlobalErrorCaptureForTests(): void {
  installed = false;
}
